import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';;

@Component({
  selector: 'app-seeder',
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './seeder.component.html',
  styleUrl: './seeder.component.css'
})
export class SeederComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showconformModal = false;
  @Output() addSeeder = new EventEmitter<any>();
  @Input() loading: boolean = false;
  showSkeleton = true;
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

    ngOnChanges(changes: SimpleChanges) {
      if (changes['loading']) {
        this.showTableLoader();
      }
    }
    ngOnInit(): void {
      this.showTableLoader();
    }

     showTableLoader(duration: number = 1500) {
    this.showSkeleton = true;
    const DEFAULT_ROWS = 5;
    const rowCount =  DEFAULT_ROWS;
    const columnCount = 4; 
    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    // Only auto-hide if not loading
    if (!this.loading) {
      setTimeout(() => {
        this.showSkeleton = false;
      }, duration);
    }
  }


    // Toggle Add/Edit or Delete modals
    toggleModal(type: 'add'| 'delete') {
      if (type === 'add') {
        this.showconformModal = !this.showconformModal;
      
      } else if (type === 'delete') {
        this.showconformModal = !this.showconformModal;
      }
    }

    confirmSave() {
      this.addSeeder.emit(true);
      this.toggleModal('delete');
    }

}
